{
  "internalPortal": {
    "components": {
      "users": {
        "title": "Users",
        "subtitle": "Client-side users and assigned internal SIB employees",
        "addUser": "New",
        "searchPlaceholder": "Search",
        "spendBrain": "SpendBrain",
        "micrositeAccess": "Microsite access",
        "subTabs": {
          "clientContacts": "Client Contacts ({{count}})",
          "sibEmployees": "SIB Employees ({{count}})",
          "clientContactsTitle": "Client Contacts",
          "sibEmployeesTitle": "SIB Employees"
        },
        "availability": {
          "available": "Available",
          "outOfOffice": "Out of office"
        },
        "previewModal": {
          "title": "Preview User"
        },
        "form": {
          "title": {
            "add": "Add User",
            "edit": "Edit User"
          },
          "fields": {
            "name": "Name",
            "email": "Email",
            "phone": "Phone",
            "status": "Status",
            "lastActive": "Last active",
            "role": "Role",
            "spendBrainAccess": "SpendBrain access"
          },
          "contactStatus": {
            "active": "Available",
            "inactive": "Inactive",
            "out_of_office": "Out of office"
          },
          "success": "User saved successfully",
          "error": "Failed to save user"
        },
        "noData": {
          "withFilters": "No users match your search. Try adjusting your search to find what you're looking for.",
          "withoutFilters": "There are currently no records to display in the Users tab. No user accounts have been linked yet."
        }
      }
    }
  }
}
